import dayjs from '~/timeInit';

import * as libRegions from '@luxuryescapes/lib-regions';

import { TourOffer } from '~/types/tours/tourOffer';

const LE_BRAND = 'luxuryescapes';
const ONLINE_PURCHASE = 'online_purchase';

/** The regions a flash hotel can be bought in right now, from its Luxury Escapes purchase schedules. */
export function hotelOnSaleRegions(offer: App.Offer, now = dayjs()): Array<string> {
  const regions = offer.brand_schedules
    .filter(
      (schedule) =>
        schedule.type === ONLINE_PURCHASE &&
        schedule.brand === LE_BRAND &&
        !now.isBefore(schedule.start) &&
        now.isBefore(schedule.end),
    )
    .map((schedule) => schedule.region);
  return [...new Set(regions)].sort();
}

const REGION_NAMES = new Map(libRegions.getRegions().map((region) => [region.code, region.name]));

export function regionName(code: string): string {
  return REGION_NAMES.get(code) ?? code;
}

/** The regions a tour is scheduled to sell in, from its schedules that haven't ended. */
export function tourScheduledRegions(offer: TourOffer, now = dayjs()): Array<string> {
  // svc-tour stores region codes in lower case.
  const regions = offer.schedules
    .filter((schedule) => now.isBefore(schedule.endDate))
    .flatMap((schedule) => schedule.regions.map((region) => region.toUpperCase()));
  return [...new Set(regions)].sort();
}

export function sharedRegions(a: Array<string>, b: Array<string>): Array<string> {
  return a.filter((region) => b.includes(region));
}
